





























import {
  Component,
  Inject,
  InjectReactive,
  Prop,
  Vue
} from "vue-property-decorator";
import { Instance } from "flatpickr/dist/types/instance";

@Component
export default class BtnChangeDate extends Vue {
  @Inject() readonly pSetSelectedDate!: Function;
  @InjectReactive() readonly pIsMobile!: boolean;
  @InjectReactive() readonly pSelectedDate!: Date;

  @Prop({ default: "" }) readonly type!: string;
  @Prop({ default: undefined }) readonly datePicker: Instance | undefined;

  get isNext() {
    return this.type === "next";
  }

  get label() {
    if (this.pIsMobile) {
      return this.isNext ? "следующий день" : "предыдущий день";
    }

    return this.isNext ? "следующий месяц" : "предыдущий месяц";
  }

  get allowClick() {
    const currDate = this.pSelectedDate;
    const minDate = this.datePicker?.config.minDate;
    const maxDate = this.datePicker?.config.maxDate;

    if (minDate && maxDate) {
      if (this.isNext) {
        return currDate < maxDate;
      } else {
        return currDate > minDate;
      }
    }

    return true;
  }

  handleClick(): void {
    if (
      this.pIsMobile &&
      this.pSelectedDate &&
      this.pSetSelectedDate &&
      this.datePicker &&
      this.allowClick
    ) {
      const pSelectedDate = this.pSelectedDate;

      let newDate: number;

      if (this.pIsMobile) {
        newDate = this.isNext
          ? pSelectedDate.getDate() + 1
          : pSelectedDate.getDate() - 1;

        this.pSetSelectedDate(pSelectedDate.setDate(newDate));
      } else {
        newDate = this.isNext
          ? pSelectedDate.getMonth() + 1
          : pSelectedDate.getMonth() - 1;

        this.pSetSelectedDate(pSelectedDate.setMonth(newDate));
      }

      this.datePicker.setDate(pSelectedDate);
    }
  }
}
